import React from 'react'
import ConfirmationModal from '../../../../components/ModalConfirmation'

interface ReceiveOrderConfirmationProps {
  isOpen: boolean
  code?: string
  title?: string
  onCancel: () => void
  onConfirm: () => void
}

// R8: receber a OC dá entrada em estoque e é irreversível — a confirmação é a
// mesma no Funil (drag-and-drop) e no menu "Alterar status" da Tabela/Quadro.
const ReceiveOrderConfirmation: React.FC<ReceiveOrderConfirmationProps> = ({
  isOpen,
  code,
  title,
  onCancel,
  onConfirm,
}) => (
  <ConfirmationModal
    isOpen={isOpen}
    title='Confirmar recebimento'
    message={
      <>
        Confirmar o recebimento do pedido <strong>{code}</strong> — {title}?
        <br />
        <br />
        O montante comprado será somado ao estoque do item (insumo ou matéria-prima) na sua unidade
        principal. Esta ação é <strong>irreversível</strong> e não poderá ser desfeita.
      </>
    }
    actions={[
      { label: 'Cancelar', onClick: onCancel, variant: 'outline' },
      { label: 'Confirmar recebimento', onClick: onConfirm, variant: 'primary' },
    ]}
  />
)

export default ReceiveOrderConfirmation
